<app-header></app-header>
<router-outlet style="overflow-x: hidden !important;" (activate)="onActivate($event)"></router-outlet>
<app-footer></app-footer>
